import { parseNovelComparison } from '@drama/contracts/novel'

import { novelAdminHttp } from './http.js'

/**
 * @callchain.routeId novel.admin.comparisons.create
 * 从源对局的当前进度建对比；不给模型时 A、B 取写作链上前两个已配好的模型。
 * @param {string} runId
 * @param {{ performer_ids?: [string, string], director_modes?: [boolean, boolean] }} [body]
 */
export async function createNovelComparison(runId, body = {}) {
  const response = await novelAdminHttp().post(`/runs/${encodeURIComponent(runId)}/comparisons`, { body, routeId: 'novel.admin.comparisons.create' })
  return parseNovelComparison(response)
}

/**
 * @callchain.routeId novel.admin.comparisons.detail
 * @param {string} comparisonId
 */
export async function getNovelComparison(comparisonId) {
  const response = await novelAdminHttp().get(`/comparisons/${encodeURIComponent(comparisonId)}`, { routeId: 'novel.admin.comparisons.detail' })
  return parseNovelComparison(response)
}

/**
 * @callchain.routeId novel.admin.comparisons.turn
 * 两边（或 side 指定的一边）各跑一回合，两边都结束才返回；不计费。
 * @param {string} comparisonId
 * @param {{ mode: string, text: string, performer_ids?: [string, string], side?: 'a'|'b' }} body
 */
export async function runNovelComparisonTurn(comparisonId, body) {
  const response = await novelAdminHttp().post(`/comparisons/${encodeURIComponent(comparisonId)}/turn`, { body, routeId: 'novel.admin.comparisons.turn' })
  return parseNovelComparison(response)
}

/**
 * @callchain.routeId novel.admin.comparisons.adopt
 * @param {string} comparisonId
 * @param {'a'|'b'} side
 */
export async function adoptNovelComparison(comparisonId, side) {
  const response = await novelAdminHttp().post(`/comparisons/${encodeURIComponent(comparisonId)}/adopt`, { body: { side }, routeId: 'novel.admin.comparisons.adopt' })
  return parseNovelComparison(response)
}

/** @callchain.routeId novel.admin.comparisons.cancel */
export async function cancelNovelComparison(comparisonId, side) {
  const response = await novelAdminHttp().post(`/comparisons/${encodeURIComponent(comparisonId)}/cancel`, { body: { side }, routeId: 'novel.admin.comparisons.cancel' })
  return parseNovelComparison(response)
}
